export default function ImpersonationBanner({ impersonatedUser, onExit }) {
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'linear-gradient(135deg, #9333ea 0%, #7c3aed 100%)',
        color: 'white',
        padding: '12px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
      }}
      data-testid="impersonation-banner"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', minWidth: 0 }}>
        <span style={{ fontSize: '20px' }}>👤</span>
        <span style={{ fontWeight: '600' }}>
          Impersonating: <strong>{impersonatedUser}</strong>
        </span>
        <span style={{ opacity: 0.8, fontSize: '14px', display: 'inline-block' }} className="impersonation-hint">
          (You are viewing the application as this user)
        </span>
      </div>
      <button
        onClick={onExit}
        style={{
          background: 'white',
          color: '#7c3aed',
          border: 'none',
          padding: '8px 20px',
          borderRadius: '8px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'transform 0.2s, box-shadow 0.2s'
        }}
        onMouseOver={(e) => {
          e.target.style.transform = 'scale(1.05)';
          e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
        }}
        onMouseOut={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = 'none';
        }}
        data-testid="exit-impersonation-button"
      >
        Exit Impersonation
      </button>
    </div>
  );
}
